import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  divider: theme => ({
    borderBottomColor: theme.colors.divider,
    borderBottomWidth: 1,
    marginTop: 20,
  }),
  editGroupDataBtn: {
    marginTop: 16,
    marginBottom: 10,
  },
  usageValuesView: {
    paddingBottom: 0,
  },
  usageItemsContainerStyle: {
    marginTop: 15,
    marginBottom: 10,
  },
  rightText: theme => ({
    color: theme.colors.activeColor,
  }),
});
